var map = {
	"./Logo-1.png": 3200,
	"./Logo-2.png": 1351,
	"./Logo-3.png": 3995,
	"./Logo-4.png": 5709,
	"./Logo.png": 9474,
	"./ada.png": 6435,
	"./ajanta.png": 8786,
	"./arx.png": 8630,
	"./astana.png": 9122,
	"./bachus.png": 7300,
	"./danone.png": 5203,
	"./esteeLauder.png": 9678,
	"./eugr.png": 8634,
	"./halyk.png": 1392,
	"./horasan.png": 3675,
	"./imstalcon.png": 114,
	"./kazakhturk.png": 6894,
	"./kazbeef.png": 7702,
	"./kbtu.png": 2384,
	"./kipros.png": 209,
	"./koa.png": 9157,
	"./kommunay.png": 3758,
	"./konica.png": 438,
	"./lifegoods.png": 4369,
	"./maryKay.png": 9798,
	"./mlombard.png": 8271,
	"./nestle.png": 5916,
	"./nursat.png": 3831,
	"./oriflame.png": 3992,
	"./petroleum.png": 2342,
	"./phaeton.png": 5392,
	"./qarabulaq.png": 7204,
	"./rbm.png": 603,
	"./rggold.png": 9584,
	"./safe.png": 9120,
	"./santo.png": 153,
	"./shym.png": 162,
	"./small.png": 5288,
	"./ssm.png": 6635,
	"./tau.png": 9851,
	"./terek.png": 4209,
	"./toimart.png": 206,
	"./vasil.png": 5076,
	"./yuzhnoGorno.png": 5745,
	"./zarechnoe.png": 4354,
	"./zeta.png": 9504,
	"./zhedel.png": 4008
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3785;